import * as React from 'react';
import './ProcedureAttachmentLink.scss';
import { LinkOutlined } from '@ant-design/icons';
import { IProcedureAttachment } from 'common/schema/ProcedureAttachment';
import { resolvePublicPath } from 'client/core/appConfig';

export interface ProcedureAttachmentLinkProps {
  attachment: IProcedureAttachment;
  key: number | string;
}

/**
 * Titolo della Domanda
 */
export function ProcedureAttachmentLink(props: ProcedureAttachmentLinkProps) {
  return (
    <a
      target="_blank"
      key={props.key}
      className="procedure-attachments-link"
      href={resolvePublicPath(props.attachment.url!)}
    >
      <LinkOutlined />
      {props.attachment.fileName}
    </a>
  );
}
